export default {
  editLocation: 'Standort bearbeiten',
  businessHours: 'Betriebszeiten',
  closed: 'Geschlossen',
  loadError: 'Der Standort konnte nicht geladen werden',
  retry: 'Erneut versuchen',
  saveError: 'Der Standort konnte nicht gespeichert werden',
  shiftsNotSaved: 'Die Zeitzone wurde gespeichert, die Betriebszeiten aber nicht',
  notMaintained: 'Es sind keine Betriebszeiten gepflegt, daher gilt der Standort als rund um die Uhr besetzt.',
  shifts: 'Schichten',
  shiftsHint: 'Die Namen der Schichten dieses Standorts. Ihre Zeiten werden unten je Tag festgelegt.',
  addShift: 'Schicht hinzufügen',
  newShiftDisplayName: 'Schicht {number}',
  shiftInUse: 'Entfernen Sie zuerst die Zeitfenster dieser Schicht',
  invalidShiftDisplayName: 'Jede Schicht braucht einen Namen, den keine andere Schicht dieses Standorts hat.',
  businessHoursHint: 'Ziehen Sie in einem Tag, um ein Zeitfenster hinzuzufügen, und ziehen Sie an seinen Griffen, um seine Zeiten zu ändern. Wählen Sie ein Zeitfenster aus, um seine Zeiten einzugeben oder seine Schicht zu ändern. Ein Zeitfenster, das vor seinem Beginn endet, endet am nächsten Tag.',
  addShiftToDay: 'Schicht zu {day} hinzufügen',
  noShift: 'Fügen Sie oben eine Schicht hinzu, um Zeitfenster hinzuzufügen.',
  allShiftsUsed: 'Jede Schicht hat am {day} bereits ein Zeitfenster.',
  overlappingWindow: 'Zeitfenster dürfen sich nicht überschneiden, auch nicht mit einem Zeitfenster des nächsten Tages.',
  continuedFrom: '{shift} (von {day})',
  timezoneChanged: {
    summary: 'Zeitzone ändert sich',
    details: 'Zeiten dieses Standorts werden in der neuen Zeitzone angezeigt. Die Betriebszeiten behalten ihre Ortszeiten.',
  },
  copy: {
    workdays: 'Für Montag–Freitag übernehmen',
    allDays: 'Für alle Tage übernehmen',
  },
};
